/**
 * Copyright 2016-2021 Sourcepole AG
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {withKeycloak} from '@react-keycloak/web';
import {setCurrentTask, setCurrentTaskBlocked} from "../../qwc2/actions/task";

class Logout extends React.Component {
    static propTypes = {
        currentTask: PropTypes.object,
        keycloak: PropTypes.object,
        side: PropTypes.string,
        task: PropTypes.string
    }
    static defaultProps = {
        side: 'right',
        task: 'Logout'
    }
    componentDidMount() {

    }
    componentDidUpdate() {
        const logout = this.props.currentTask && this.props.currentTask.id === this.props.task;
        if (logout) {
            this.props.keycloak.logout();
        }
    }
    onShow() {
    }
    render() {
        return null;
    }

}
const selector = (state) => ({
    currentTask: state.task
});

export default connect(selector, {
    setCurrentTask: setCurrentTask,
    setCurrentTaskBlocked: setCurrentTaskBlocked
})(withKeycloak(Logout));
